import Vue from 'vue';
import FailModal from './FailModal';

const newInstance = (data = {}) => {
    const instance = new Vue({
        data,
        render(createElement) {
            return createElement(FailModal, {});
        }
    });
    const component = instance.$mount();

    document.body.appendChild(component.$el);

    const failModal = instance.$children[0];

    return {
        open(props) {
            for (const key in props) {
                if (typeof key !== 'function') {
                    failModal[key] = props[key];
                }
            }

            failModal.visible = true;
        }
    };
};

let failModal = null;

function open(options) {
    failModal = failModal || newInstance();

    failModal.open(options);
}


FailModal.install = () => {
    Vue.$failModal = Vue.prototype.$failModal = {
        open(props = {}) {
            open(props);
        }
    };
};

export default FailModal;



// WEBPACK FOOTER //
// ./src/components/FailModal/index.js